import React__default, { useState } from 'react';
import { useUniqueId } from '../utils/use-unique-id.js';
import { useTranslation } from '../useTranslation/use-translation.js';
import { Button } from '../Button/Button.js';
import InfoCircle2FillIcon from '../Icon/icons/InfoCircle2Fill.js';
import InfoCircle2Icon from '../Icon/icons/InfoCircle2.js';
import { CollapsibleContent } from '../Collapsible/CollapsibleContent.js';
import { HelpContent } from '../shared/HelpContent/HelpContent.js';
import { SmallText } from '../SmallText/SmallText.js';

const useHelpButton = _ref => {
  let {
    labelId,
    helpButtonLabel,
    className,
    helpText
  } = _ref;
  const helpId = useUniqueId('help');
  const helpButtonId = useUniqueId('help-button');
  const [isHelpVisible, setIsHelpVisible] = useState(false);
  const {
    getTranslation
  } = useTranslation();
  const helpButton = /*#__PURE__*/React__default.createElement(Button, {
    ariaLabelledby: [helpButtonId, labelId].filter(Boolean).join(' '),
    id: helpButtonId,
    ariaControls: helpId,
    ariaExpanded: isHelpVisible,
    className: className,
    icon: isHelpVisible ? /*#__PURE__*/React__default.createElement(InfoCircle2FillIcon, null) : /*#__PURE__*/React__default.createElement(InfoCircle2Icon, null),
    onClick: () => setIsHelpVisible(isVisible => !isVisible),
    variant: "plain"
  }, helpButtonLabel || getTranslation('moreInformation'));
  const helpContent = helpText ? /*#__PURE__*/React__default.createElement(CollapsibleContent, {
    "aria-live": "polite",
    id: helpId,
    isOpen: isHelpVisible
  }, /*#__PURE__*/React__default.createElement(HelpContent, null, typeof helpText === 'string' ? /*#__PURE__*/React__default.createElement(SmallText, {
    noMargin: true
  }, helpText) : helpText)) : null;
  return {
    helpButton,
    helpContent,
    helpId
  };
};

export { useHelpButton };
